<template>
	<v-container fluid class="ma-0 pa-0">
    <Header />
    <v-col class="pa-0" id="main_content_maxwidthset" cols="12">
      <v-row class="ma-0 pa-0 pt-5 pb-5" justify="end">
        <v-col class="ma-0 pa-0 pr-3" cols="auto" align-self="center">
          {{`期間`}}: 
        </v-col>
        <v-col class="ma-0 pa-0" cols="1">
          <v-select id="month_select" background-color="#272727" dark
		      	:items="monthList" dense hide-details outlined 
		      	item-text="label" item-value="value" v-model="selectedMonth"
		      ></v-select>
        </v-col>
      </v-row>
      <v-row class="ma-0 pa-0" justify="space-between">
        <v-col class="ma-0 pa-0" id="chart_box" cols="4" v-for="(item, index) in testData" :key="index">
          <v-col class="ma-2 mt-0 mb-6 pa-0" cols="auto" id="chart_background">
            <v-col class="ma-0 pa-0" cols="12">
							<v-row class="ma-0 pa-4" align="center" justify="space-between"
								style="font-weight:bold;">
								<v-col id="data_sub_title" class="ma-0 pa-0" cols="auto">
									{{'過去30日の来客数'}}
								</v-col>
								<v-col class="ma-0 pa-0" cols="auto">
									<v-row class="ma-0 pa-0" align="center"
										style="color: #008DD0;font-size:0.8rem;cursor:pointer;">
										{{'分析を見る'}}
										<v-img max-height="0.8rem" max-width="0.8rem" class="ma-0 pa-0 ml-2"
											src="@/assets/images/blue_right_icon.png"></v-img>
									</v-row>
								</v-col>
							</v-row>
              <v-row class="ma-0 pa-0 pt-5" justify="center">
                <DoughnutChart id="doughnut_chart" :data="item.chartData" :options="chartOptions" 
					      	:width="120" :height="120"></DoughnutChart>
					      <v-col id="chart_percent" class="ma-0 pa-0" cols="auto">
					      	{{Math.floor((item.chartData.datasets[0].data[0] / (item.chartData.datasets[0].data[0] + item.chartData.datasets[0].data[1]))*100)}}
                  <span style="font-size:0.8em;">{{'%'}}</span>
					      </v-col>
              </v-row>
            </v-col>
          </v-col>
        </v-col>
      </v-row>
		</v-col>
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import Header from './components/Header.vue';
import DoughnutChart from "../../components/doughnutChart.js";
import { OtherStoreDatas } from '../whitetest/sampleData';
export default {
	components: {
		Header, DoughnutChart
	},
	mixins: [mixin.common],
	data: () => ({
		onlinePercent: '',
    selectedMonth: '1月',
		navItems: [
      {
        name: '自店舗分析',
        path: '/store-search/store-cctv',
        icon: 'all_store',
      },
      {
        name: '他店舗分析',
        path: '/store-search/other-store',
        icon: 'store_group',
      },
      {
        name: '監視カメラ',
        path: '/store-search/store-cctv',
        icon: 'cctv',
      }
    ],
    monthList: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
		chartOptions: {
			maintainAspectRatio: false,
      responsive: false,
      legend: {
      	display: false
      },
			cutoutPercentage: 75 // line 굵기
    },
    testData: OtherStoreDatas,
	}),
	created() {
  },
  mounted() {
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
.v-list {
  background: #171921;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item__title{
    color: white;
  }
  .v-input__slot {
		padding-right: 2px !important;
	}
	.v-input__append-inner {
		margin-top: 16px !important;
		padding-left: 0px !important;
	}
  // Select Box Height 설정
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 35px !important;
	}
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control {
		height: 35px;
	}
}
#chart_box {
	position: relative;
  // background: #34363C;
}
#chart_background {
	position: relative;
  background: #34363C;
  height: 14em;
  border-radius: 5px;
}
#chart_percent {
	position: absolute;
	top: 56.5%;
	left: 50%;
	transform: translate(-47%, -40%);
	font-size: 1.5rem;
  font-weight: 500;
}
#doughnut_chart{
  z-index: 4;
}
#data_sub_title {
	color: #CECED0;
	font-size: 0.8rem;
}
</style>